import { FC } from 'react';

import { Form, InputNumber, InputNumberProps } from 'antd';
import { FormItemProps } from 'antd/lib';

import './InputFormItem.scss';

interface INumberInputFormItemProps {
	formItemProps: FormItemProps;
	inputNumberProps?: InputNumberProps<number>;
}

export const NumberInputFormItem: FC<INumberInputFormItemProps> = ({
	formItemProps,
	inputNumberProps,
}) => {
	return (
		<Form.Item
			className={'input'}
			{...formItemProps}
			rules={formItemProps.rules ?? [{ required: true }]}
		>
			<InputNumber
				data-testid="number-input"
				inputMode="numeric"
				style={{ width: '100%' }}
				{...inputNumberProps}
			/>
		</Form.Item>
	);
};
